/**
 * 記事本文のギャラリー画像ブロック（c_article-block-image）の拡大 dialog。
 *
 * dialog のスライドは Liquid では出力せず、初回 open 時にインラインカルーセルの
 * img を複製して作る。初期 DOM と画像リクエストを増やさないため。
 */
const DIALOG_IMAGE_SIZES = '(min-width: 600px) 60vw, 100vw';

// c_common.js は head の defer、このモジュールは body。どちらも文書順に実行されるため基底は定義済み
class CArticleImageDialog extends customElements.get('c-splide-dialog') {
  beforeMount() {
    this.buildSlides();
    super.beforeMount();
  }

  /** インラインカルーセルの img からスライドを組み立てる */
  buildSlides() {
    const list = this.querySelector('.splide__list');
    if (!list || list.children.length > 0) return;

    const source = document.getElementById(this.dataset.articleImageSource);
    if (!source) return;

    const slides = source.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    const fragment = document.createDocumentFragment();

    slides.forEach((slide) => {
      const sourceImage = slide.querySelector('img');
      if (!sourceImage) return;

      const item = document.createElement('li');
      item.className = 'splide__slide';

      // sizes はインライン用の表示幅で計算されているため dialog 用に差し替える
      const image = sourceImage.cloneNode(false);
      image.setAttribute('sizes', DIALOG_IMAGE_SIZES);
      image.setAttribute('loading', 'lazy');
      image.removeAttribute('fetchpriority');
      item.appendChild(image);

      fragment.appendChild(item);
    });

    list.appendChild(fragment);
  }
}

customElements.define('c-article-image-dialog', CArticleImageDialog);
